// 全景图数据配置
// 从View.vue中提取的views数组数据

// 讲解音频映射表
export const audioMap = {
    0: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/序厅.mp3',
    1: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/序厅.mp3',
    2: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第一展区.mp3',
    3: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第二展区.mp3',
    4: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第二展区.mp3',
    5: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第二展区.mp3',
    6: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第二展区.mp3',
    7: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第二展区.mp3',
    8: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第三展区.mp3',
    9: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/第三展区.mp3',
    // 尾厅（索引10和11）播放尾厅的讲解
    10: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/尾厅.mp3',
    11: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/尾厅.mp3'
};

// 背景音乐列表
export const bgMusicList = [
    'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/理想与信念.mp3',
    'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/人物风景纪录片.mp3'
];

// 全景图视图数据
export const panoramaViews = [
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1.jpg',
                    // 初始视角配置
                    'initialView': {
                        'pitch': -3,    // 垂直角度：-90(向下) 到 90(向上)，0为水平
                        'yaw': -5,     // 水平角度：0-360，0为正前方
                        'hfov': 110     // 视野范围：30-120，数值越大视野越宽
                    },
                    'hotspots': [
                        {
                            pitch: 2.1,
                            yaw: 242.9,
                            type: 'info',
                            text: '序厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/0-序厅-1.png'
                        },
                        {
                            pitch: 3,
                            yaw: -88,
                            type: 'info',
                            text: '妫川脊梁 时代荣光',
                            videoSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/妫川脊梁时代荣光.mp4'
                        },
                        {
                            pitch: 3,
                            yaw: 85,
                            type: 'info',
                            text: '结束语',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/结束语.jpg'
                        }
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 15,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch: 3,
                            yaw: 110,
                            type: 'info',
                            text: '妫川脊梁 时代荣光',
                            videoSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/妫川脊梁时代荣光.mp4'
                        },
                         {
                            pitch:  2.1,
                            yaw: 0,
                            type: 'info',
                            text: '序厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/0-序厅-1.png'
                        }
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 67,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: 13,
                            type: 'info',
                            text: '第一展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/hall1.png'
                        },
                        {
                            pitch:  12.1,
                            yaw: 70,
                            type: 'info',
                            text: '高万红',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-2.png'
                        },
                         {
                            pitch:  12.1,
                            yaw: 40,
                            type: 'info',
                            text: '第一展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-3.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 325,
                            type: 'info',
                            text: '郭宽/张玉海',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-4.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 310,
                            type: 'info',
                            text: '孙连重',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-5.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 285,
                            type: 'info',
                            text: '张树凯/陈克新',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-6.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 265,
                            type: 'info',
                            text: '许维潘',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-7.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 245,
                            type: 'info',
                            text: '郭丰瑞/赵景延',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-8.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 220,
                            type: 'info',
                            text: '贾桂英/王义宽',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-9.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 200,
                            type: 'info',
                            text: '王永善/赵连振',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/1-第一展厅-10.png'
                        }
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/4.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 80,
                        'hfov': 110
                    },
                    'hotspots': [
                       {
                            pitch:  2.1,
                            yaw: 123,
                            type: 'info',
                            text: '第二展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/hall2.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 83,
                            type: 'info',
                            text: '时间线',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-2.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 25,
                            type: 'info',
                            text: '司永春/卫桂英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-3.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 15,
                            type: 'info',
                            text: '杨进福/闫茂先',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-4.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 195,
                            type: 'info',
                            text: '卓会卿/曹广忠',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-8.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 215,
                            type: 'info',
                            text: '张成厚/刘进喜/葛长林',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-9.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 235,
                            type: 'info',
                            text: '潘宗旺/王恺/霍尚均',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-10.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 265,
                            type: 'info',
                            text: '张经武/英立海/哈云潮',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-11.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 285,
                            type: 'info',
                            text: '孟树至/董慧明/杜壮',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-12.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 305,
                            type: 'info',
                            text: '韩书琴/张进元/赵丽霞',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-13.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 315,
                            type: 'info',
                            text: '冯富先/梁贵昌/田富善',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-14.png'
                        }
                        ,
                        {
                            pitch:  2.1,
                            yaw: 322,
                            type: 'info',
                            text: '夏庆华/宋书海/唐成厚',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-15.png'
                        }
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/5.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 100,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: 22,
                            type: 'info',
                            text: '夏庆华/宋书海/唐成厚',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-15.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 37,
                            type: 'info',
                            text: '张金连/梁三英/马永存',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-16.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 77,
                            type: 'info',
                            text: '马文宗/李维贤',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-17.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 100,
                            type: 'info',
                            text: '胡富元/张志本/穆永富',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-18.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 123,
                            type: 'info',
                            text: '赵相清/陈留伏/张瑞先',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-19.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 133,
                            type: 'info',
                            text: '李海深/张葆兰/赵运兴',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-20.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 140,
                            type: 'info',
                            text: '费东风/万艳辉/周尚友',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-21.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 145,
                            type: 'info',
                            text: '李德茂/武书田/王利华',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-22.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 145,
                            type: 'info',
                            text: '李德茂/武书田/王利华',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-22.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 170,
                            type: 'info',
                            text: '张长来/王久昌/周爱英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-23.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 240,
                            type: 'info',
                            text: '姬有/王双林/张连中',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-7.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 265,
                            type: 'info',
                            text: '康雨/张秀云/徐瑞玲',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-6.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 290,
                            type: 'info',
                            text: '王学亮/贺鸿文',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-5.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: 305,
                            type: 'info',
                            text: '杨进福/闫茂先',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-4.png'
                        }
                        ,
                         {
                            pitch:  2.1,
                            yaw: 313,
                            type: 'info',
                            text: '司永春/卫桂英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-3.png'
                        }
                    ]
                },
                
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/7.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 167,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: -180,
                            type: 'info',
                            text: '李海深/张葆兰/赵运兴',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-20.png'
                        },
                         {
                            pitch:  2.1,
                            yaw: -140,
                            type: 'info',
                            text: '费东风/万艳辉/周尚友',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-21.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -100,
                            type: 'info',
                            text: '李德茂/武书田/王利华',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-22.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 30,
                            type: 'info',
                            text: '张艳霞/曹树田/霍桂兰',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-24.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/6.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 167,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: 5,
                            type: 'info',
                            text: '夏庆华/宋书海/唐成厚',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-28.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 25,
                            type: 'info',
                            text: '郭良瑜/尤秉德/张凤林',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-27.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 110,
                            type: 'info',
                            text: '李志东/耿会芹/郭宏绪',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-26.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 130,
                            type: 'info',
                            text: '赵华军/闫云峰/冯亚玲',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/2-第二展厅-25.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -80,
                            type: 'info',
                            text: '第三展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/hall3.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -30,
                            type: 'info',
                            text: '第三展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-2.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/8.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': -47,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: 30,
                            type: 'info',
                            text: '韩文兴/时二小',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-3.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 90,
                            type: 'info',
                            text: '段学锋/刘金柱',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-4.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -50,
                            type: 'info',
                            text: '第三展厅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-2.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 180,
                            type: 'info',
                            text: '李慧敏/赵俊英/安尚丽',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-11.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 230,
                            type: 'info',
                            text: '卢淑娟/鲁秀臣',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-10.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 170,
                            type: 'info',
                            text: '陈威/苗美成',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-13.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 160,
                            type: 'info',
                            text: '刘曼宜/刘玉泉/桂彩丽',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-14.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 152,
                            type: 'info',
                            text: '赵方红/陶汪系/康梅利',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-15.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/9.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 147,
                        'hfov': 110
                    },
                    'hotspots': [
                        // {
                        //     pitch: 6,
                        //     yaw: 150,
                        //     type: 'info',
                        //     text: '妫川脊梁 时代荣光',
                        //     videoSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/妫川脊梁时代荣光.mp4'
                        // },
                        {
                            pitch:  2.1,
                            yaw: 0,
                            type: 'info',
                            text: '何梅英/闫立凯/池凤英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-17.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 40,
                            type: 'info',
                            text: '贺艳霞/除丽娟/张良军',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-16.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 55,
                            type: 'info',
                            text: '赵方红/陶汪来/康柏利',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-15.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 65,
                            type: 'info',
                            text: '刘曼宜/刘玉泉/桂彩丽',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-14.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -40,
                            type: 'info',
                            text: '李慧民/王长民/张建秋/韩凤英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-12.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -85,
                            type: 'info',
                            text: '王嵘/司亮/郭芳',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-22.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -100,
                            type: 'info',
                            text: '杨国红/苏振海/马秋荣/雷蕾',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-23.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -150,
                            type: 'info',
                            text: '吴海波/吕立鑫',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-7.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -175,
                            type: 'info',
                            text: '韩平/秦志伟',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-6.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -230,
                            type: 'info',
                            text: '徐建喜/张洪波/臧东梅',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-5.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: -243,
                            type: 'info',
                            text: '段学锋/刘金柱',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-4.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/10.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 17,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch:  2.1,
                            yaw: 0,
                            type: 'info',
                            text: '尹振萍/王猛',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-8.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 50,
                            type: 'info',
                            text: '张庆/张富云',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-9.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 190,
                            type: 'info',
                            text: '王盈盈/王利强/薛雪菲/李洁',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-21.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 170,
                            type: 'info',
                            text: '杨国红/苏振海/马秋荣/雷蕾',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-23.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 178,
                            type: 'info',
                            text: '王嵘/司亮/郭芳',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-22.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 202,
                            type: 'info',
                            text: '于海宽/贺玉玲/董喜英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-20.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 212,
                            type: 'info',
                            text: '陈双来/贾庆华/贺玉凤',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-19.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 225,
                            type: 'info',
                            text: '李慧民/王长民/张建秋/韩凤英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-12.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 235,
                            type: 'info',
                            text: '何梅英/闫立凯/池凤英',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-17.png'
                        },
                        {
                            pitch:  2.1,
                            yaw: 242,
                            type: 'info',
                            text: '贺艳霞/陈丽娟/张良军',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/3-第三展厅-16.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/11.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': -37,
                        'hfov': 110
                    },
                    'hotspots': [
                        //  {
                        //     pitch: 6,
                        //     yaw: 140,
                        //     type: 'info',
                        //     text: '妫川脊梁 时代荣光',
                        //     videoSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/妫川脊梁时代荣光.mp4'
                        // },
                        {
                            pitch:  2.1,
                            yaw: 202,
                            type: 'info',
                            text: '人名墙',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/4-人名墙.png'
                        },
                    ]
                },
                {
                    'image': 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/12.jpg',
                    'initialView': {
                        'pitch': -3,
                        'yaw': 17,
                        'hfov': 110
                    },
                    'hotspots': [
                        {
                            pitch: 3,
                            yaw: 10,
                            type: 'info',
                            text: '结束语',
                            imageSrc: 'https://online-1368622751.cos.ap-shanghai.myqcloud.com/assets/结束语.jpg'
                        }
                    ]
                },
            ];
